import {createStateMaker} from '@shared/helpers/object'

import {SaleSettlementState} from '../interfaces'

export const getInitialState = (): SaleSettlementState => ({
    paymentDate: '',
    summary: {
        complete: {
            amount: 0,
            count: 0,
        },
        expect: {
            amount: 0,
            count: 0,
        },
        detail: {
            totalAmount: 0,
            baseAmount: 0,
            productOrderAmount: 0,
            extraFeeAmount: 0,
            deductionRestoreAmount: 0,
            deliveryFeeAmount: 0,
            etcAmount: 0,
            minusSetOffAmount: 0,
            payHoldBackAmount: 0,
        },
    },
    payHold: {
        status: 'IDLE',
        selected: {
            startDate: '',
            endDate: '',
        },
        items: [],
        totalAmount: 0,
    },
})

export const makeMock = createStateMaker<SaleSettlementState>(getInitialState)
